export default "__VITE_ASSET__DPol9huq__"